export default "__VITE_ASSET__BTpQ$E25__"